<template>
  <div
    v-if="hiddenTags.length"
    class="popover-component tag-overflow-popover relative inline-block"
    :data-popover-pos="position"
    v-click-outside="hide"
  >
    <button
      ref="trigger"
      type="button"
      class="tag tag--overflow tag-overflow-popover__trigger border-0 cursor-pointer"
      @click.stop="toggle"
    >
      +{{ hiddenTags.length }}
    </button>

    <div
      v-if="open"
      ref="body"
      class="tag-overflow-popover__panel bg-producer-slate-popover fixed z-[1000] flex max-w-[min(240px,calc(100vw-24px))] flex-wrap items-start gap-1.5 rounded-[2px] p-[10px] shadow-[0_4px_8px_rgba(0,0,0,0.25)]"
      :style="popoverStyle"
    >
      <span
        v-for="tag in hiddenTags"
        :key="tag"
        class="tag tag--overflow tag-overflow-popover__item cursor-default whitespace-nowrap"
      >
        {{ tag }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagOverflowPopover',
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
    position: {
      type: String,
      default: 'up-right',
    },
    sliceOffset: {
      type: Number,
      default: 2,
    },
  },

  data() {
    return {
      open: false,
      popoverStyle: {},
    };
  },

  computed: {
    hiddenTags() {
      return this.tags.slice(this.sliceOffset);
    },
  },

  methods: {
    toggle() {
      this.open = !this.open;

      if (this.open) {
        this.$nextTick(this.positionPopover);
      }
    },

    hide() {
      this.open = false;
      this.popoverStyle = {};
    },

    positionPopover() {
      const trigger = this.$refs.trigger;
      const body = this.$refs.body;

      if (!trigger || !body) {
        return;
      }

      const triggerRect = trigger.getBoundingClientRect();
      const bodyRect = body.getBoundingClientRect();
      const gap = 8;
      const margin = 12;

      let top = triggerRect.bottom + gap;
      let left = triggerRect.right - bodyRect.width;

      if (this.position === 'up-right') {
        top = triggerRect.top - bodyRect.height - gap;
      } else if (this.position === 'up-left') {
        top = triggerRect.top - bodyRect.height - gap;
        left = triggerRect.left;
      } else if (this.position === 'down-left') {
        left = triggerRect.left;
      } else if (this.position === 'down') {
        left = triggerRect.left + (triggerRect.width / 2) - (bodyRect.width / 2);
      } else if (this.position === 'up') {
        top = triggerRect.top - bodyRect.height - gap;
        left = triggerRect.left + (triggerRect.width / 2) - (bodyRect.width / 2);
      }

      this.popoverStyle = {
        position: 'fixed',
        top: `${Math.max(margin, top)}px`,
        left: `${Math.max(margin, left)}px`,
        zIndex: 1000,
      };
    },
  },
};
</script>
